import haversine from "haversine-distance";

export const addLineItemsToCreateOrderRequests = (
  parsedLineItems,
  createOrderRequests,
) => {
  const lineItemData = parsedLineItems["data"]["lineItemRequests"];

  let orderIdLineItemMap = {};

  for (const lineItem of lineItemData) {
    orderIdLineItemMap[lineItem["orderId"]] = lineItem["data"];
  }

  for (let i = 0; i < createOrderRequests.length; i++) {
    const createOrderRequest = createOrderRequests[i];
    createOrderRequest["lineItems"] =
      orderIdLineItemMap[createOrderRequest["id"]];
  }

  return createOrderRequests;
};

function getUniqueLocationRequests(createLocationRequests) {
  let locationIds = new Set();
  let uniqueLocationRequests = [];

  for (let i = 0; i < createLocationRequests.length; i++) {
    const locationRequest = createLocationRequests[i];

    if (locationIds.has(locationRequest["id"])) {
      continue;
    }

    locationIds.add(locationRequest["id"]);
    uniqueLocationRequests.push(locationRequest);
  }

  return uniqueLocationRequests;
}

export const updateOrderLocations = (
  createOrderRequests,
  createLocationRequests,
  homebases,
) => {
  let homebaseIdMap = {};
  for (const homebase of homebases) {
    homebaseIdMap[homebase["id"]] = homebase;
  }

  let locationIdOrderIdMap = {};
  let orderIdHomebaseIdMap = {};

  for (let i = 0; i < createOrderRequests.length; i++) {
    const createOrderRequest = createOrderRequests[i];
    locationIdOrderIdMap[createOrderRequest["locationId"]] =
      createOrderRequest["id"];
    orderIdHomebaseIdMap[createOrderRequest["id"]] =
      createOrderRequest["homebaseId"];
  }

  for (let i = 0; i < createOrderRequests.length; i++) {
    const createOrderRequest = createOrderRequests[i];
    const latLng = createOrderRequest["latLng"];

    if (latLng === null || latLng === undefined) {
      continue;
    }

    const orderLongitude = latLng["lng"],
      orderLatitude = latLng["lat"];

    if (orderLatitude === undefined || orderLongitude === undefined) {
      createOrderRequest["latLng"] = null;
      continue;
    }

    if (
      (orderLatitude === "0" && orderLongitude === "0") ||
      (orderLatitude === "0.0" && orderLongitude === "0.0") ||
      (orderLatitude === 0 && orderLongitude === 0) ||
      (orderLatitude === 0.0 && orderLongitude === 0.0)
    ) {
      createOrderRequest["latLng"] = null;
      continue;
    }

    const homebaseId = createOrderRequest["homebaseId"];
    const homebase = homebaseIdMap[homebaseId];

    if (homebase === undefined) {
      continue;
    }

    const homebaseLatLng = homebase["latLng"];
    if (homebaseLatLng === undefined) {
      continue;
    }

    const distanceInMetres = haversine(
      createOrderRequest["latLng"],
      homebaseLatLng,
    );

    const distanceInKm = distanceInMetres / 1000;
    if (distanceInKm > 30) {
      createOrderRequest["latLng"] = null;
      continue;
    }

    createOrderRequest["locationAddress"] = null;
    createOrderRequest["latLng"] = null;
  }

  if (createLocationRequests.length === 0) {
    return { createOrderRequests, createLocationRequests };
  }

  createLocationRequests = getUniqueLocationRequests(createLocationRequests);

  for (let i = 0; i < createLocationRequests.length; i++) {
    const createLocationRequest = createLocationRequests[i];
    const latLng = createLocationRequest["latLng"];

    if (latLng === null || latLng === undefined) {
      continue;
    }

    const locationLongitude = latLng["lng"],
      locationLatitude = latLng["lat"];

    if (locationLongitude === undefined || locationLatitude === undefined) {
      createLocationRequest["latLng"] = null;
      continue;
    }

    if (
      (locationLatitude === "0" && locationLongitude === "0") ||
      (locationLatitude === "0.0" && locationLongitude === "0.0") ||
      (locationLatitude === 0 && locationLongitude === 0) ||
      (locationLatitude === 0.0 && locationLongitude === 0.0)
    ) {
      createLocationRequest["latLng"] = null;
    }

    const homebaseId =
      homebaseIdMap[locationIdOrderIdMap[createLocationRequest["id"]]];

    if (homebaseId === null || homebaseId === undefined) {
      continue;
    }

    const homebase = homebaseIdMap[homebaseId];

    if (homebase === undefined || homebase === null) {
      continue;
    }

    const homebaseLatLng = homebase["latLng"];
    if (homebaseLatLng === undefined || homebaseLatLng === null) {
      continue;
    }

    const distanceInMetres = haversine(
      createLocationRequest["latLng"],
      homebaseLatLng,
    );

    const distanceInKm = distanceInMetres / 1000;
    if (distanceInKm > 30) {
      createLocationRequest["latLng"] = null;
    }
  }

  return { createOrderRequests, createLocationRequests };
};
